import React from 'react';
import ReactDOM, { createPortal } from 'react-dom';
import { Link } from 'react-router-dom'
import NewsList from './Newlist.js'
import sun from '../img/sun.png'
import left from '../img/left.png'
import right from '../img/right.png'
import icon3 from '../img/icon3.png'
import icon4 from '../img/icon4.png'
import icon7 from '../img/icon7.png'
import loading from '../img/loding.gif'
import er from '../img/er.png'
import { getIp, getNewsList, getStock } from '../api/api'
import html2canvas from 'html2canvas'
const { Solar, Lunar, HolidayUtil } = require('lunar-javascript')
const jsonp = require('jsonp')



function getMothEn(params) {
  switch (params) {
    case 1:
      return 'January'
    case 2:
      return 'February'
    case 3:
      return 'March'
    case 4:
      return 'April'
    case 5:
      return 'May'
    case 6:
      return 'June'
    case 7:
      return 'July'
    case 8:
      return 'August'
    case 9:
      return 'September'
    case 10:
      return 'October'
    case 11:
      return 'November'
    case 12:
      return 'December'
  }
}
function getMothNum(params) {
  switch (params) {
    case 1:
      return '一'
    case 2:
      return '二'
    case 3:
      return '三'
    case 4:
      return '四'
    case 5:
      return '五'
    case 6:
      return '六'
    case 7:
      return '七'
    case 8:
      return '八'
    case 9:
      return '九'
    case 10:
      return '十'
    case 11:
      return '十一'
    case 12:
      return '十二'
  }
}

function getWeek(params) {
  let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  return weeks[params]
}






class CalendarItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      city: {},
      weather: {
        observe: {
          degree: ''
        },
        limit: {
          tail_number: ''
        }
      },
      lunar: {
        year: '',
        shengxiao: '',
        month: '',
        day: '',
        date: ''
      },
      date: new Date(),
      isSHowLayer: false,
      canvasImg: '',
      newsList: [],
      isshowLoading: true,
      stockList: []

    }
  }

  componentDidMount() {
    //先拿ip 确定区域 高德ip定位接口


    getIp().then(res => {
      console.log(res)
      this.setState({
        city: {
          city: res.data.ad_info.city,
          district: res.data.ad_info.district,
          province: res.data.ad_info.province
        },
        weather: res.data.data
      })
    })





    //农历
    // this.setState({
    //   lunar: {
    //     year: Lunar.fromDate(this.state.date).getYearInGanZhi() + '年',
    //     shengxiao: '【' + Lunar.fromDate(this.state.date).getYearShengXiao() + '年】',
    //     month: Lunar.fromDate(this.state.date).getMonthInGanZhi() + '月',
    //     day: Lunar.fromDate(this.state.date).getDayInGanZhi() + '日',
    //     date: Lunar.fromDate(this.state.date).getMonthInChinese() + '月' + Lunar.fromDate(this.state.date).getDayInChinese()
    //   }
    // })
    // console.log(Lunar.fromDate(this.state.date).getYearInGanZhi())
    this.getLunar()
    this.getNews()
    this.getStockList()
  }

  getNews = () => {
    getNewsList({
      date: this.state.date.getFullYear() + '-' + Number(this.state.date.getMonth() + 1) + '-' + this.state.date.getDate()
    }).then(res => {
      console.log(res)
      this.setState({
        newsList: res.data.events[0].events
      })
    })
  }

  getStockList = () => {
    getStock().then(res => {
      console.log(res.data.data)
      this.setState({
        stockList: res.data.data
      })
    })
  }

  getLunar = () => {
    this.setState({
      lunar: {
        year: Lunar.fromDate(this.state.date).getYearInGanZhi() + '年',
        shengxiao: '【' + Lunar.fromDate(this.state.date).getYearShengXiao() + '年】',
        month: Lunar.fromDate(this.state.date).getMonthInGanZhi() + '月',
        day: Lunar.fromDate(this.state.date).getDayInGanZhi() + '日',
        date: Lunar.fromDate(this.state.date).getMonthInChinese() + '月' + Lunar.fromDate(this.state.date).getDayInChinese()
      }
    })
  }

  debounce(fn, wait) {
    var timeout = null;      //定义一个定时器
    return function () {
      if (timeout !== null)
        clearTimeout(timeout);  //清除这个定时器
      timeout = setTimeout(fn, wait);
    }
  }



  nextDay = () => {
    let day = this.state.date



    this.setState({
      date: new Date(day.getTime() + 1000 * 60 * 60 * 24)
    }, () => {
      this.getNews()
    })
    this.getLunar()




  }

  prevDay = () => {
    let day = this.state.date

    this.setState({
      date: new Date(day.getTime() - 1000 * 60 * 60 * 24)
    }, () => {
      this.getNews()
    })
    this.getLunar()

  }

  nowDay = () => {

    this.setState({
      date: new Date()
    }, () => {
      this.getNews()
    })
    this.getLunar()

  }

  closeLayer = () => {
    this.setState({
      isSHowLayer:false,
      isshowLoading: true,
    })
  }


  canvasImg = () => {
    this.setState({
      isSHowLayer: true,
      isshowLoading: true
    })
    setTimeout(() => {

      html2canvas(document.getElementById('bg'), {
        backgroundColor: 'transparent',
        useCORS: true,

      }).then((canvas) => {
        let url = canvas.toDataURL("image/png");
        this.setState({
          isSHowBottom: false,
          canvasImg: url,
          isshowLoading: false,
        })

      });


    }, 1000)

  }
  render() {
    return (
      <div className="m-bg" id='bg'>
        <div className='m-nongli'>
          <p >
            农历·{this.state.lunar.date}
          </p>
          <p>
            {this.state.lunar.year} {this.state.lunar.shengxiao} {this.state.lunar.month} {this.state.lunar.day}
          </p>
        </div>

        <div className='m-date-area'>
          <div className='u-area-left'>
            <p className='u-area-mon'>
              {getMothNum(this.state.date.getMonth() + 1)}月 {getMothEn(this.state.date.getMonth() + 1)}
            </p>
            <p className='u-area-day'>
              {this.state.date.getDate()}
            </p>
            <p className='u-area-week'>
              {this.state.date.getMonth() + 1}月{this.state.date.getDate()}日 / {getWeek(this.state.date.getDay())}
            </p>
          </div>
          <div className='u-area-right'>
            <div className='u-area-weather'>
              <div className='u-weather'>
                <img src={sun} className='u-weather-icon' />
                {this.state.weather.observe.weather}
              </div>
              <div className='u-temperature'>
                <p className='u-temperature-now'>
                  <b>{this.state.weather.observe.degree}</b>℃
                </p>
                <p className='u-temperature-day'>
                  {this.state.weather.limit.tail_number.split('和')[0]}℃ / {this.state.weather.limit.tail_number.split('和')[1]}℃
                </p>
                <p className='u-area-name'>
                  {this.state.city.district}
                </p>
              </div>

            </div>
            <div className='u-list'>

              {
                this.state.stockList.map(item => {
                  return (
                    <div className='u-list-item'>
                      <div className='u-stock-name'>{item.symbol}</div>
                      <div className={item.fluctuationRange > 0 ? 'u-stock-roate up' : 'u-stock-roate down'}>
                        <span>{item.tradePrice}</span>
                        <span>{item.fluctuationRange}%</span>
                      </div>
                    </div>
                  )
                })
              }






            </div>


          </div>


        </div>

        <NewsList list={this.state.newsList} />


        {
          !this.state.isSHowLayer ?

            <div className='g-bottom' >
              <div className='m-choose-day' >
                <img src={left} onClick={this.prevDay} />
                <span onClick={this.nowDay}>今天</span>

                <img src={right} onClick={this.nextDay} />
              </div>
              <div className='m-buttons'>
                <div onClick={this.canvasImg}>
                  <img src={icon4} />
                  生成图片
                </div>
                <Link to='/AllCalendar'>
                  <img src={icon7} />
                  列表模式
                </Link>

              </div>
            </div>
            :
            <div className='u-er-show'>

              <img src={er} className='u-er' />
              <p className='u-er-text'>长按识别二维码下载每经APP</p>
            </div>
        }


        {createPortal(

          this.state.isSHowLayer ?
            <div className='g-layer'>
              {
                this.state.isshowLoading ?
                  <div className='u-loading'>
                    <img src={loading} />
                    <p>图片生成中...</p>
                  </div>

                  :
                  <div className='u-canvasImg'>
                    <img src={this.state.canvasImg}  />
                    <a href='javascript:void(0)' className='u-close' onClick={ this.closeLayer}>
                      关闭
                    </a>
                  </div>
                  
                  
              }



            </div>
            : ''
          , document.getElementById('root'))}

      </div>

    )
  }
}

export default CalendarItem